import { DefineComponent, defineComponent } from 'vue';

import GeofenceContextMenu from './GeofenceContextMenu.vue';
import MapBoxPopupBuilder from './MapBoxPopupBuilder';

/**
 * @description Extracts all the keys from a type that doesn't start with a `$`
 * @author Our dear Chat-GPT
 */
type ExcludeKeysStartingWithDollar<T> = Pick<T, Exclude<keyof T, `$${string}`>>;

type GeofenceContextMenuMethods = ExcludeKeysStartingWithDollar<InstanceType<typeof GeofenceContextMenu>>;

class GeofenceContextMenuBuilder extends MapBoxPopupBuilder {
  constructor(map: mapboxgl.Map, methodOverrides: Partial<GeofenceContextMenuMethods>) {
    super(
      map,
      defineComponent({
        extends: GeofenceContextMenu,
        setup: GeofenceContextMenu.setup,
        methods: methodOverrides,
      }) as unknown as DefineComponent,
    );
  }
}

export default GeofenceContextMenuBuilder;
